import {
    Injectable,
    ElementRef,
    ComponentRef
} from '@angular/core';

@Injectable()
export class ToastrRef {
    elementRef: ElementRef;

    constructor(
    ) {
        const element = document.createElement('div');
        element.classList.add('toastr', '--ui');

        document.body.appendChild(element);

        this.elementRef = new ElementRef(element);
    }

    push<T>(componentRef: ComponentRef<T>) {
        this.elementRef.nativeElement.appendChild(componentRef.location.nativeElement);
    }

    pull<T>(componentRef: ComponentRef<T>) {
        this.elementRef.nativeElement.removeChild(componentRef.location.nativeElement);
    }
}
